import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import Boxoutline from "../../../../../../../media/images/icons/outline-box";
import { ITenderOfferDeatails } from "..";
import LocationFill from "../../../../../../../media/images/icons/location-fill";
import ArrowStepLeft from "../../../../../../../media/images/icons/arrow-steps-register";

export default function TenderInfo(props: ITenderOfferDeatails) {
  const { weight, orderDate, source, destination, goodsName, status } = props;

  const theme = useTheme();
  return (
    <Box
      sx={{
        boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
        display: "flex",
        borderColor: "info.main",
        borderStyle: "solid",
        borderWidth: "1px",
        borderRadius: "10px",
        flexDirection: "column",
        padding: "8px",
        backgroundColor: "background.default",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "info.light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "6px",
            borderRadius: "8px",
          }}
        >
          <Boxoutline color={theme.palette.textColor.main} />
        </Box>

        <Box
          sx={{
            flex: "1",
            display: "flex",
            gap: "4px",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              {goodsName || "-------"}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: theme.palette.primary[50],
                padding: "4px",
                borderRadius: "5px",
                gap: "4px",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "primary.main",
                }}
              >
                وزن محموله:
              </Typography>
              <Typography
                noWrap
                sx={{
                  fontSize: "12px",
                  fontWeight: "700",
                  color: "primary.main",
                }}
              >
                {(weight / 1000).toFixed(1)} تن
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "normal",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: "12px",
                }}
              >
                تاریخ ثبت بار:
              </Typography>
              <Box
                sx={{
                  backgroundColor: "info.light",
                  padding: "4px",
                  borderRadius: "5px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  {orderDate}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                borderRadius: "6px",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                }}
              >
                وضعیت:
              </Typography>

              {status === 1 ? (
                <Box
                  sx={{
                    flex: "1",
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: theme.palette.secondary[50],
                    padding: "4px",
                    borderRadius: "5px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "700",
                      color: "secondary.main",
                    }}
                  >
                    درحال بررسی
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    flex: "1",
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: theme.palette.success.light,
                    padding: "4px",
                    borderRadius: "5px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "700",
                      color: "success.main",
                    }}
                  >
                    مجوز صادر شده
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "info.light",
          paddingY: "8px",
          paddingX: "4px",
          borderRadius: "8px",
          borderColor: "info.main",
          borderWidth: "1px",
          borderStyle: "solid",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: "1",
            justifyContent: "center",
            gap: "4px",
          }}
        >
          <LocationFill size={18} color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "12px",
            }}
          >
            {source}
          </Typography>
        </Box>
        <ArrowStepLeft color={theme.palette.textColor.main} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "1",
            gap: "4px",
          }}
        >
          <LocationFill size={18} color={theme.palette.secondary.main} />
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "12px",
            }}
          >
            {destination}{" "}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
